import React from "react";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { useGStore } from "../../../../context/Context";
import CollectorTable from "./CollectorTable/CollectorTable";
import { format } from "date-fns";

const CollectorAccounting = () => {
  const {state } = useGStore()
  const {collectors,collectorPayments} = state;
  const todayDate = new Date();
  const todayFormatDate = format(todayDate, "PP");

  const todayPayments =  collectorPayments.filter(payments => payments.paymentDate.split(",")[0].split(" ")[1] === todayFormatDate.split(",")[0].split(" ")[1])
// console.log(todayPayments)
  const totalCollectorPayments = collectorPayments.reduce((a,b)=> a + parseInt(b.payAmount),0)
  const totalTodayPayments = todayPayments.reduce((a,b)=> a + parseInt(b.payAmount),0)

  // console.log(totalTodayPayments, totalCollectorPayments);
  return (
    <div>
        <h2 className="my-5"><ConvertEnglish english={'Collector bill'} bangla={"কালেক্টর বিল"}/></h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-12">
      {
        collectors &&  collectors.map(collector =>
     <CollectorTable key={collector._id} totalCollectorPayments={totalCollectorPayments} totalTodayPayments={totalTodayPayments} collector={collector}></CollectorTable> 
        )
      }
      </div>
    </div>
  );
};

export default CollectorAccounting;
